import { css } from '@emotion/react';
import { Box, Button, Flex, Text, desktopFirstMediaQuery } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

import { INFLEARN_B2B_URL } from '../../../../constants/urls';

export const SubscriptionCoursesContactSection = () => {
  const { t } = useTranslation();

  return (
    <Box component="section" bg="gray.0">
      <Flex gap={16} align="center" justify="space-between" css={styleContainer}>
        <Flex direction="column" gap={4}>
          <Text fw={600} size="lg">
            {t('subscription_courses.contact.title')}
          </Text>
          <Text size="sm" c="gray.6">
            {t('subscription_courses.contact.description')}
          </Text>
        </Flex>
        <Button size="md" radius="md" component="a" href={INFLEARN_B2B_URL.SUPPORT()}>
          {t('subscription_courses.cta.contact')}
        </Button>
      </Flex>
    </Box>
  );
};

const styleContainer = css({
  margin: '0 auto',
  maxWidth: 1200,
  padding: '48px 32px',
  [desktopFirstMediaQuery.tablet]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '32px 16px',
  },
});
